import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { v4 } from 'uuid';
import classNames from 'classnames';
import { Action } from '@prism/actions';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var _excluded$1 = ["active", "addOnAppend", "addOnPrepend", "className", "iconOnly", "disabled", "label", "onClick", "size", "textOnly"];
var TabSizes$2 = ['sm', 'md'];

var TabItem = function TabItem(_ref) {
  var active = _ref.active,
      addOnAppend = _ref.addOnAppend,
      addOnPrepend = _ref.addOnPrepend,
      classNameFromProps = _ref.className,
      propIconOnly = _ref.iconOnly,
      disabled = _ref.disabled,
      label = _ref.label,
      onClick = _ref.onClick,
      size = _ref.size,
      propTextOnly = _ref.textOnly,
      props = _objectWithoutProperties(_ref, _excluded$1);

  var iconOnly = propIconOnly || !label;
  var textOnly = propTextOnly || !(addOnAppend || addOnPrepend);

  var handleClick = function handleClick(e) {
    if (onClick) {
      onClick(e);
    }
  };

  var className = classNames('tab', {
    active: !!active
  }, classNameFromProps);
  return /*#__PURE__*/React.createElement(Action, _extends({}, props, {
    disabled: disabled,
    className: className,
    onClick: props.href ? null : handleClick,
    addOnAppend: addOnAppend,
    addOnPrepend: addOnPrepend,
    iconOnly: iconOnly,
    textOnly: textOnly,
    label: !iconOnly ? label : null,
    role: "tab",
    size: size,
    "aria-selected": !!active
  }), label && !iconOnly && /*#__PURE__*/React.createElement("span", {
    className: "tab-label"
  }, label));
};

TabItem.propTypes = {
  active: PropTypes.bool,
  addOnAppend: PropTypes.string,
  addOnPrepend: PropTypes.string,
  className: PropTypes.string,
  iconOnly: PropTypes.bool,
  label: function label(props) {
    var hasIcon = props.addOnAppend || props.addOnPrepend;

    if (!hasIcon && typeof props.label !== 'string') {
      return new Error('Invalid prop sequence. Either `label`, `addOnAppend`, `addOnPrepend`, or a combination must be supplied; none were given to ');
    }

    return null;
  },
  onClick: PropTypes.func,
  size: PropTypes.oneOf(TabSizes$2),
  textOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  href: PropTypes.string
};
TabItem.defaultProps = {
  active: false,
  addOnAppend: '',
  addOnPrepend: '',
  className: '',
  iconOnly: false,
  onClick: function onClick() {},
  size: TabSizes$2[1],
  textOnly: false,
  disabled: false,
  label: '',
  href: null
};
TabItem.displayName = 'TabItem';

var TabBar = function TabBar(_ref) {
  var border = _ref.border,
      classNameFromProps = _ref.className,
      children = _ref.children,
      id = _ref.id;
  var className = classNames('tab-bar', classNameFromProps, {
    'has-border': border
  });
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    id: id
  }, /*#__PURE__*/React.createElement("ul", {
    className: "nav nav-tabs",
    role: "tablist"
  }, children));
};

TabBar.propTypes = {
  border: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
TabBar.defaultProps = {
  border: false,
  className: null,
  id: null,
  children: null
};
TabBar.displayName = 'TabBar';

/* eslint-disable react/require-default-props */

var TabPane = function TabPane(props) {
  var classNameFromProps = props.className,
      children = props.children,
      disabled = props.disabled,
      id = props.id,
      isAnimated = props.isAnimated,
      active = props.active,
      labelledby = props.labelledby;
  var isActive = active && !disabled;
  var className = classNames(classNameFromProps, 'tab-pane', {
    fade: isAnimated,
    show: isActive,
    active: isActive
  });
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: className,
    role: "tabpanel",
    "aria-labelledby": labelledby
  }, children);
};

TabPane.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  isAnimated: PropTypes.bool,
  labelledby: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
TabPane.defaultProps = {
  active: false,
  className: '',
  disabled: false,
  isAnimated: true,
  labelledby: '',
  children: null
};
TabPane.displayName = 'TabPane';

var _excluded = ["content", "disabled", "label", "tabClassName", "tabId"];
var TabSizes$1 = ['sm', 'md'];
function useTabs(props) {
  var propActiveIndex = props.activeIndex,
      border = props.border,
      children = props.children,
      classNameFromProps = props.className,
      color = props.color,
      data = props.data,
      iconOnly = props.iconOnly,
      id = props.id,
      onChange = props.onChange,
      size = props.size,
      textOnly = props.textOnly;

  var _useState = useState(propActiveIndex),
      _useState2 = _slicedToArray(_useState, 2),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  var _useState3 = useState(React.Children.toArray(children)),
      _useState4 = _slicedToArray(_useState3, 2),
      childArray = _useState4[0],
      setChildArray = _useState4[1];

  var normalizeTabProps = function normalizeTabProps(tabProps) {
    var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;

    var newProps = _objectSpread2({
      iconOnly: iconOnly,
      textOnly: textOnly,
      id: "".concat(id, "-").concat(index),
      size: size || TabSizes$1[1]
    }, tabProps);

    delete newProps.children;
    delete newProps.isAnimated;
    delete newProps.panelIndex;
    return newProps;
  };

  var dataToTabPropsAndContent = function dataToTabPropsAndContent(config) {
    var content = config.content,
        disabled = config.disabled,
        label = config.label,
        tabClassName = config.tabClassName,
        tabId = config.tabId,
        args = _objectWithoutProperties(config, _excluded);

    var contentProps = {
      className: classNames(tabClassName),
      disabled: disabled,
      id: args.id
    };

    if (typeof label === 'string') {
      contentProps.label = label;
    } else {
      if (label.text) {
        contentProps.label = label.text;
      }

      if (label.icon) {
        contentProps.addOnPrepend = label.icon;
      }
    }

    return [normalizeTabProps(contentProps), /*#__PURE__*/React.createElement("div", {
      className: classNames(args.className),
      id: tabId
    }, content)];
  };

  var tabPropsFromChildrenOrData = function tabPropsFromChildrenOrData(_ref) {
    var childrenProp = _ref.children,
        dataObj = _ref.data;

    if (dataObj && Array.isArray(dataObj)) {
      return dataObj.map(dataToTabPropsAndContent).map(function (t) {
        return t[0];
      });
    }

    return React.Children.toArray(childrenProp).map(function (ch, idx) {
      return normalizeTabProps(ch.props, idx);
    });
  };

  var _useState5 = useState(tabPropsFromChildrenOrData({
    children: children,
    data: data
  })),
      _useState6 = _slicedToArray(_useState5, 2),
      tabs = _useState6[0],
      setTabs = _useState6[1];

  useEffect(function () {
    var childArrayObj = React.Children.toArray(children);
    setTabs(childArrayObj.map(function (ch, idx) {
      return normalizeTabProps(ch.props, idx);
    }));
    setChildArray(childArrayObj);
  }, [size, children]);
  useEffect(function () {
    if (data && Array.isArray(data)) {
      var tabPropsAndContent = data.map(dataToTabPropsAndContent);
      setTabs(tabPropsAndContent.map(function (t) {
        return t[0];
      }));
      setChildArray(tabPropsAndContent.map(function (t) {
        return t[1];
      }));
    }
  }, [data]);

  var updateHandleClick = function updateHandleClick(index) {
    return function (e) {
      if (index === activeIndex) {
        return;
      }

      setActiveIndex(index);

      if (tabs[index].onClick) {
        tabs[index].onClick(e);
      }

      if (onChange) {
        onChange(_objectSpread2(_objectSpread2({}, e), {}, {
          prevActiveIndex: index,
          activeIndex: activeIndex
        }));
      }
    };
  };

  var className = classNames('tabs', 'tab-container', _defineProperty({}, "tabs-".concat(color), !!color), classNameFromProps);
  var childrenProps = tabs.length ? tabs : tabPropsFromChildrenOrData({
    children: children,
    data: data
  });
  return {
    childrenProps: childrenProps,
    className: className,
    childArray: childArray,
    updateHandleClick: updateHandleClick,
    id: id,
    tabs: tabs,
    border: border,
    activeIndex: activeIndex
  };
}

var TabColors = ['light', 'dark'];
var TabSizes = ['sm', 'md'];

var Tabs = function Tabs(props) {
  var _useTabs = useTabs(props),
      childArray = _useTabs.childArray,
      childrenProps = _useTabs.childrenProps,
      className = _useTabs.className,
      id = _useTabs.id,
      border = _useTabs.border,
      activeIndex = _useTabs.activeIndex,
      tabs = _useTabs.tabs,
      updateHandleClick = _useTabs.updateHandleClick;

  var handleTabClick = function handleTabClick(index) {
    return updateHandleClick(index);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: className,
    id: id
  }, /*#__PURE__*/React.createElement(TabBar, {
    border: border
  }, childrenProps.map(function (tabProps, index) {
    var keyId = "".concat(id, "-tab-").concat(index);
    return /*#__PURE__*/React.createElement("li", {
      key: keyId,
      className: "nav-item"
    }, /*#__PURE__*/React.createElement(TabItem, _extends({}, tabProps, {
      active: activeIndex === index,
      onClick: handleTabClick(index)
    })));
  })), /*#__PURE__*/React.createElement("div", {
    className: "tab-content"
  }, childArray.map(function (child, index) {
    var keyId = "".concat(id, "-pane-").concat(index);
    return /*#__PURE__*/React.createElement(TabPane, _extends({}, child.props, {
      active: activeIndex === index,
      key: keyId,
      panelIndex: index,
      labelledby: tabs[index] ? tabs[index].id : null
    }));
  })));
};

Tabs.propTypes = {
  activeIndex: PropTypes.number,
  border: PropTypes.bool,
  className: PropTypes.string,
  color: PropTypes.oneOf(TabColors),
  data: PropTypes.arrayOf(PropTypes.shape({
    activeIndex: PropTypes.number,
    className: PropTypes.string,
    content: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    id: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
      icon: PropTypes.string,
      text: PropTypes.string
    })]),
    tabClassName: PropTypes.string,
    tabId: PropTypes.string
  })),
  iconOnly: PropTypes.bool,
  id: PropTypes.string,
  onChange: PropTypes.func,
  size: PropTypes.oneOf(TabSizes),
  textOnly: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
Tabs.defaultProps = {
  activeIndex: 0,
  border: true,
  color: TabColors[0],
  id: v4(),
  className: '',
  data: null,
  iconOnly: false,
  onChange: function onChange() {},
  size: TabSizes[1],
  textOnly: false,
  children: null
};
Tabs.displayName = 'Tabs';

Tabs.TabBar = TabBar;
Tabs.TabItem = TabItem;
Tabs.TabPane = TabPane;

export { TabBar, TabItem, TabPane, Tabs as default };
//# sourceMappingURL=index.js.map
